import Box from '@mui/material/Box'
import { observer } from 'mobx-react'
import React from 'react'

import AppBar from '@mui/material/AppBar'
import withWidth, { isWidthUp } from '@mui/material/Hidden/withWidth'
import IconButton from '@mui/material/IconButton'
import AppbarTitle from 'src/components/Appbar/AppbarTitle/AppbarTitle'
import { useAuth } from 'src/services/AuthProvider'
import menu from '../../assets/images/common/menu.svg'
import avatarToAdmin from '../../assets/images/layout/avatarToAdmin.svg'
import exitIcon from '../../assets/images/layout/exitWhite.svg'
import adminLogo from '../../assets/images/layout/RThreeColorLogo.svg'
import { isAdmin, isOperator } from '../../services/AccountService'
import commonStyles from '../../styles/commonStyles'
import { gState } from '../../utils/controllers/GlobalStateController'
import { getStyles } from '../../utils/utils/commonUtils'
import DateAndTime from '../DateAndTime/DateAndTime'
import layoutStyles from '../Layout/styles/layoutStyles'
import AppbarUserInfo from './AppbarUserInfo'

import { useRouteTitle } from './useRouteTitle'

function Appbar({ toggleMenu, width }) {
  const { logout } = useAuth()
  const classes = { ...getStyles(commonStyles), ...getStyles(layoutStyles) }

  const { title, href } = useRouteTitle()

  return (
    <AppBar component={'header'} sx={classes.appbar}>
      <Box className={'aln-center'} sx={{ gap: '15px' }}>
        {!isOperator() && (
          <IconButton onClick={toggleMenu} sx={classes.adminBtn}>
            <img draggable='false' alt={'burger icon'} src={menu} />
          </IconButton>
        )}
        {isWidthUp('sm', width) && gState['roles'] && (
          <Box ml={1.5} sx={{ display: 'flex', alignItems: 'center' }}>
            {isAdmin() && (
              <img draggable='false' alt={'logo'} src={adminLogo} />
            )}
          </Box>
        )}
        <AppbarTitle title={title} href={href} />
      </Box>
      <DateAndTime />
      <Box className={'aln-center'}>
        <Box sx={{ ...classes.adminAccInfo }}>
          <img draggable='false' alt={'avatarToAdmin'} src={avatarToAdmin} />

          <AppbarUserInfo />
        </Box>
        <IconButton sx={classes.adminBtn} onClick={logout}>
          <img draggable='false' alt={'exit'} src={exitIcon} />
        </IconButton>
      </Box>
    </AppBar>
  )
}

export default withWidth()(observer(Appbar))
